import { formatAmount } from "@/helpers/decimal_helper";

export const CurrencyColumn = ({ amount, onClick, style = {} }) => {

    return (
        <div className="d-flex" onClick={onClick}
            style={{ cursor: onClick ? "pointer" : "default", ...style }}
        >
            <span>₱ {formatAmount(amount)}</span>
        </div>
    )
}
